import { useCallback, useEffect, useState } from "react";
import { getCologuardDashboardMetrics } from "../services/api.js";

const EMPTY_INVENTORY = {
  total_codes: 0,
  available_codes: 0,
  requested_codes: 0,
  released_codes: 0,
  order_attached_codes: 0,
  blocked_codes: 0,
  assigned_codes: 0,
  redeemed_codes: 0,
  redeemed_release_received_codes: 0,
  successfully_released_order_codes: 0,
  redemption_rate: null,
  true_redemption_rate: null,
  delivered_codes: 0,
  order_redemption_codes: 0,
  order_redemption_rate: null,
  code_released_codes: 0,
  code_released_rate: null,
  unrealized_codes: 0,
  unrealized_rate: null,
  true_redemption_codes: 0,
  delivered_true_redemption_rate: null,
  redemption_metrics_available: false,
  redemption_metrics_version: null,
  updated_at: null,
};

const EMPTY_ACTIVITY = {
  days: [],
  totals: { requests_started: 0, releases_completed: 0, orders_attached: 0 },
};

export default function useDashboardMetrics({
  isAuthenticated,
  accessToken,
  campaignDesignators = [],
}) {
  const campaignDesignatorKey = campaignDesignators.join(",");
  const [metricsState, setMetricsState] = useState({
    loading: false,
    error: "",
    inventory: EMPTY_INVENTORY,
    activity: EMPTY_ACTIVITY,
    campaigns: [],
    generatedAt: null,
  });

  const loadDashboardMetrics = useCallback(async ({ silent = false } = {}) => {
    if (!isAuthenticated) return;
    if (!silent) {
      setMetricsState((current) => ({ ...current, loading: true, error: "" }));
    }

    try {
      const result = await getCologuardDashboardMetrics({
        activityDays: 7,
        campaignDesignators: campaignDesignatorKey ? campaignDesignatorKey.split(",") : [],
        accessToken,
      });
      setMetricsState({
        loading: false,
        error: "",
        inventory: result.inventory || EMPTY_INVENTORY,
        activity: result.activity || EMPTY_ACTIVITY,
        campaigns: result.campaigns || [],
        generatedAt: result.generated_at || null,
      });
    } catch (error) {
      setMetricsState((current) => ({
        ...current,
        loading: false,
        error: error.message,
      }));
    }
  }, [accessToken, campaignDesignatorKey, isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) return undefined;
    loadDashboardMetrics();
    const intervalId = window.setInterval(() => {
      if (document.visibilityState === "visible") loadDashboardMetrics({ silent: true });
    }, 30000);
    return () => window.clearInterval(intervalId);
  }, [isAuthenticated, loadDashboardMetrics]);

  return { metricsState, loadDashboardMetrics };
}
